module.exports = __webpack_public_path__ + "img/application-icon03.c2b9ed38.png";